import { runDemo } from "../shared/demoRunner";
import { createBumpScene } from "./scene";

runDemo({
    createScene: createBumpScene,
});
